import { render, staticRenderFns } from "./IconTempBig.vue?vue&type=template&id=3cb24616"
import script from "./IconTempBig.vue?vue&type=script&lang=js"
export * from "./IconTempBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports